// 403 页：能力不足的统一落点。

import { Link } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Button, EmptyState } from "@bf/ui";

export function ForbiddenPage() {
  const { user } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f5f6f7] p-6">
      <EmptyState
        title="没有访问权限"
        description={user ? `${user.name}，当前账号未被授予该页面的访问能力，请联系系统管理员。` : "请先登录后再试。"}
        action={
          <Link to="/">
            <Button variant="primary">返回工作台</Button>
          </Link>
        }
      />
    </div>
  );
}
